import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router";
import { withTranslation } from "react-i18next";
import { withRouter, useLocation } from "react-router-dom";
import { DigitalVaultUploadView } from '../../views';
import { CategoryService, CompanyService, LocalStorageService, DigitalVaultDocumentService, ClientService } from '../../../services';
import { countCreditsByPages, filterFilesPDF, getFileMediaType } from '../../../utils';
import { PDFDocument } from 'pdf-lib';

const DigitalVaultUploadAction = (props) => {

    let {
        documentId,
        documentData,
        handleSaveData,
        noWorkflow,
        handleSubmitNoWorkflow,
        t
    } = props

    const history = useHistory();
    const { search } = useLocation();

    const url = process.env.REACT_APP_MIFIRMA_API;
    const localStorageService = new LocalStorageService();
    const companyService = new CompanyService(url);
    const categoryService = new CategoryService(url);
    const digitalVaultDocumentService = new DigitalVaultDocumentService(url);
    const preferenceService = new ClientService(url)
    const ENV = process.env

    const token = localStorageService.getLocalStorageItem("token").idToken;
    const timezone = localStorageService.getLocalStorageItem("timezone");

    const [firstLoad, setFirstLoad] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [showLoadingRequesting, setShowLoadingRequesting] = useState(false);
    const [showErrorRequesting, setShowErrorRequesting] = useState(false);
    const [showCompletedRequesting, setShowCompletedRequesting] = useState(false);
    const [messageError, setMessageError] = useState('');
    const [invalidFields, setInvalidFields] = useState([]);
    const [fileType, setFileType] = useState("pdf")

    const infoTypes = [
        { id: 1, name: t("digitalVaultUploadView.type.document") },
        { id: 2, name: t("digitalVaultUploadView.type.exp") }
    ];
    const [companies, setCompanies] = useState([{ id: 0, companyName: t("digitalVaultUploadView.unassigned") }]);
    const [categories, setCategories] = useState([{ id: 0, name: t("digitalVaultUploadView.unassigned") }]);
    const [subcategoryTree, setSubcategoryTree] = useState([]);
    const [typeDocuments, setTypeDocuments] = useState([]);
    const [showUploadBtn, setShowUploadBtn] = useState(true)
    const [urlPdf, setUrlPdf] = useState(url)
    const [blobAWS, setBlobAWS] = useState(url);
    const [showBtnCancel, setShowBtnCancel] = useState(false)
    const [uploadData, setUploadData] = useState({
        infoType: 1,
        name: "",
        companyId: null,
        categoryId: null,
        pathBreadcrumb: [],
        typeDocument: null,
        uploadedFiles: [],
    });
    const [showDialogSendDocToOcr, setShowDialogSendDocToOcr] = useState(false)
    const [documentsToOCR, setDocumentsToOCR] = useState([])
    const [totalCredits, setTotalCredits] = useState(0)

    const toggleErrorRequesting = (value, message, time, sendInbox) => {
        setShowErrorRequesting(value)
        setMessageError(message)

        if (value) {
            setTimeout(() => {
                setShowErrorRequesting(false)
                if (sendInbox) {
                    history.push("/");
                }
            }, time);
        }
    }

    const pdfToBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        }
        );

    const handleFiles = async (e) => {
        let newFiles = [];

        for (let i = 0; i < e.target.files.length; i++) {
            const fileBase64 = await pdfToBase64(e.target.files[i]);
            const pdfBase64 = fileBase64.split(",")[1];
            const fileType = getFileMediaType(e.target.files[i], "type")
            newFiles.push({
                name: e.target.files[i].name,
                file: e.target.files[i],
                fileBase64: pdfBase64,
                type: e.target.files[i].type,
                fileType
            })
        }

        setInvalidFields(prev => prev.filter(i => i !== "files"))
        setUploadData(prev => {
            let files = []
            if (prev.infoType == 1) {
                files = [newFiles[0]]
            } else {
                files = [...prev.uploadedFiles]
                for (let i = 0; i < newFiles.length; i++) {
                    if (!files.find(f => f.name == newFiles[i].name)) {
                        files.push(newFiles[i])
                    }
                }
            }


            return {
                ...prev,
                uploadedFiles: files
            }
        });
        setFileType(newFiles[0].fileType)
    };

    const deleteFile = (file) => {
        setUploadData(prev => {
            const updatedFiles = prev.uploadedFiles.filter(f => f.name != file.name && f.fileBase64 != file.fileBase64);
            return {
                ...prev,
                uploadedFiles: updatedFiles
            }
        })
    }

    const loadCompanies = async () => {
        setIsLoading(true);

        try {
            const response = await companyService.getUsersCompanies(token)
            if (response.statusCode == 200 && response.data) {
                let companyOptions = response.data.map(el => el.company);
                companyOptions.sort((a, b) => a.companyName.toLowerCase().localeCompare(b.companyName.toLowerCase()));
                companyOptions = [{ id: 0, companyName: t("digitalVaultUploadView.unassigned") }, ...companyOptions]
                setCompanies(companyOptions);

                const params = new URLSearchParams(search);
                const companyIdParam = params.get("companyId");
                if (params.length == 0 || params.length == 1) setFirstLoad(false);
                handleUploadDataChange("companyId", companyIdParam || companyOptions[0].id);
            } else {
                throw new Error(response.message || t("digitalVaultUploadView.errors.general.load.companies"))
            }
            setIsLoading(false);
        } catch (e) {
            toggleErrorRequesting(true, e.message, 4000, true)
        }
    }

    const loadCategories = async (companyId = uploadData.companyId) => {
        setShowLoadingRequesting(true);

        try {
            const response = await categoryService.getCategories(token, companyId);
            if (response.statusCode == 200 && response.data) {
                let categoryOptions = response.data;
                categoryOptions.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
                categoryOptions = [{ id: 0, name: t("digitalVaultUploadView.unassigned") }, ...categoryOptions]
                setCategories(categoryOptions);
                setSubcategoryTree([]);

                let i = null;
                if (uploadData.categoryId && uploadData.categoryId != 0) {
                    i = categoryOptions.find(c => c.id == uploadData.categoryId)
                } else {
                    const params = new URLSearchParams(search);
                    const categoryIdParam = params.get("categoryId");

                    if (categoryIdParam) {
                        i = categoryOptions.find(c => c.id == parseInt(categoryIdParam))
                        if (params.length == 2) setFirstLoad(false);
                    }
                }
                if (i) {
                    await loadSubcategories(uploadData.categoryId, uploadData.companyId);
                }
                await handleUploadDataChange("categoryId", i ? i.id : 0);
            } else {
                throw new Error(response.message || t("digitalVaultUploadView.errors.general.load.categories"))
            }
            setShowLoadingRequesting(false);
        } catch (e) {
            toggleErrorRequesting(true, e.message, 4000, true)
        }
    }

    const loadSubcategories = async (categoryId = uploadData.categoryId, companyId = uploadData.companyId) => {
        if (!categoryId || !companyId) return;

        setShowLoadingRequesting(true);
        try {
            const response = await categoryService.getSubcategories(token, companyId, categoryId);
            if (response.statusCode == 200 && response.data) {
                setSubcategoryTree(response.data);
                setFirstLoad(false);

                const params = new URLSearchParams(search);
                const pathParam = params.get("path");
                if (pathParam) {
                    let path = pathParam.split(",").map(i => parseInt(i))
                    await handleUploadDataChange("pathBreadcrumb", path);
                } else {
                    let pathBreadcrumb = (uploadData && uploadData.pathBreadcrumb) ? uploadData.pathBreadcrumb : null
                    await handleUploadDataChange("pathBreadcrumb", pathBreadcrumb);
                }
            } else {
                throw new Error(response.message || t("digitalVaultUploadView.errors.general.load.categories"))
            }
            const typeDocumentParam = infoTypes.find(item => item.id === +uploadData.infoType).name
            getTypeDocuments(typeDocumentParam)
            setShowLoadingRequesting(false);
        } catch (e) {
            toggleErrorRequesting(true, e.message, 4000, true)
        }
    }

    const handleUploadDataChange = async (field, value) => {
        setUploadData(prev => ({
            ...prev,
            uploadedFiles: field == "infoType" ? [] : prev.uploadedFiles,
            [field]: value
        }))
    }

    useEffect(() => {
        if (uploadData.companyId != null) {
            if (uploadData.companyId == 0) setCategories([{ id: 0, name: t("digitalVaultUploadView.unassigned") }])
            else loadCategories(uploadData.companyId)
        }
    }, [uploadData.companyId])

    useEffect(() => {
        if (uploadData.categoryId != null) {
            if (uploadData.categoryId == 0) {
                setSubcategoryTree([])
                setTypeDocuments([])
            }
            else loadSubcategories(uploadData.categoryId);
        }
    }, [uploadData.categoryId])

    useEffect(() => {
        if (!firstLoad && !documentId) {
            history.replace({ pathname: `/digital-vault-upload` })
        }
    }, [firstLoad])

    const onCancel = () => history.goBack();

    const validateData = () => {
        let invalidFields = [];
        if (uploadData.name.trim() == "") {
            invalidFields.push("name")
        }
        if (uploadData.categoryId == 0) {
            invalidFields.push("categoryId")
        }
        if (!uploadData.typeDocument || uploadData.typeDocument.name.trim() == "") {
            invalidFields.push("typeDocument")
        }
        if (!uploadData.pathBreadcrumb || uploadData.pathBreadcrumb.length == 0) {
            invalidFields.push("pathBreadcrumb")
        }
        if (uploadData.uploadedFiles.length == 0) {
            invalidFields.push("files")
        }
        setInvalidFields(invalidFields)
        return invalidFields.length == 0
    }

    const validateUpdateData = () => {
        let invalidFields = [];
        if (uploadData.name.trim() == "") {
            invalidFields.push("name")
        }
        if (uploadData.categoryId == 0) {
            invalidFields.push("categoryId")
        }
        if (!uploadData.typeDocument || uploadData.typeDocument.name.trim() == "") {
            invalidFields.push("typeDocument")
        }
        if (!uploadData.pathBreadcrumb || uploadData.pathBreadcrumb.length == 0) {
            invalidFields.push("pathBreadcrumb")
        }
        setInvalidFields(invalidFields)
        return invalidFields.length == 0
    }

    const onSave = async (searcPreference, ocrSelected) => {
        if (!validateData()) {
            toggleErrorRequesting(true, t("digitalVaultUploadView.errors.complete.all.fields"), 3000, false);
            return;
        };

        setShowLoadingRequesting(true);

        let timezone = localStorageService.getLocalStorageItem("timezone");

        let data = new FormData();
        let infoType = infoTypes.find(i => i.id == uploadData.infoType)
        data.append("timezone", timezone);
        data.append("infoType", infoType.name);
        data.append("name", uploadData.name);
        data.append("companyId", uploadData.companyId);
        data.append("categoryId", uploadData.pathBreadcrumb[uploadData.pathBreadcrumb.length - 1]);
        data.append("pathBreadcrumb", [uploadData.categoryId, ...uploadData.pathBreadcrumb].join('/'));
        data.append("workflowId", process.env.REACT_APP_ID_NEW_DOCUMENT);

        if (uploadData.typeDocument.id == -1) {
            const name = uploadData.typeDocument.name;
            const typeDocument = typeDocuments.find(i => i.name.toLowerCase() == name.toLowerCase())
            data.append("newTypeDocumentName", typeDocument ? typeDocument.name : name);
        } else {
            data.append("typeDocumentId", uploadData.typeDocument.id);
        }
        uploadData.uploadedFiles.forEach((f) => {
            data.append(f.name, f.file);
        });

        try {
            let preferenceSendAllDocsToOcr = false
            if (searcPreference) {
                let showModalOCR = true
                let userPreferences = await preferenceService.getClientPreferences(token, timezone);
                let sendDocsToOcrPreference = userPreferences.data.find(preference => preference.preferenceName === process.env.REACT_APP_PREFERENCE_DOCUMENT_TO_OCR)
                if (sendDocsToOcrPreference) {
                    let preferenceOCR = (!sendDocsToOcrPreference.stringValue || (sendDocsToOcrPreference.stringValue && sendDocsToOcrPreference.stringValue === ENV.REACT_APP_OPTIONS_SEND_DOCUMENT_TO_OCR_USER_SELECT)) ? true : false
                    if (!preferenceOCR) showModalOCR = false
                    preferenceSendAllDocsToOcr = (sendDocsToOcrPreference && sendDocsToOcrPreference.stringValue === ENV.REACT_APP_OPTIONS_SEND_DOCUMENT_TO_OCR_ALL_DOCUMENTS) ? true : false
                    if (!ocrSelected) ocrSelected = sendDocsToOcrPreference.stringValue
                }

                //Verify preference if is active show modal to select if send document to OCR or not
                if (showModalOCR) {
                    let docsShowModal = [...uploadData.uploadedFiles];

                    let docsToSendToOCR = [];
                    let docsNotToSendToOCR = [];


                    for (let index = 0; index < docsShowModal.length; index++) {
                        const file = docsShowModal[index];

                        if (file.type === 'application/pdf') {
                            try {
                                const arrayBuffer = await file.file.arrayBuffer();
                                const pdfDoc = await PDFDocument.load(arrayBuffer);
                                const pages = pdfDoc.getPages();
                                file.id = null;
                                file.pages = (pages) ? pages.length : 0;
                                docsToSendToOCR.push(file);
                            } catch (error) {
                                console.error('Error al procesar el archivo PDF:', error);
                            }
                        } else {
                            docsNotToSendToOCR.push(file);
                        }
                    }

                    let docsCreditsOCR = setCreditsToDocuments(docsToSendToOCR);
                    let docsCredits = docsCreditsOCR && docsCreditsOCR.documentsToOCR ? docsCreditsOCR.documentsToOCR : [];
                    let totalCredits = docsCreditsOCR && docsCreditsOCR.totalCredits ? docsCreditsOCR.totalCredits : 0;

                    setTotalCredits(totalCredits);
                    setDocumentsToOCR(docsCredits);

                    setShowLoadingRequesting(false);
                    setShowDialogSendDocToOcr(true);

                    return;
                }

            }

            let dataFilesToOCR = []
            let sendFilesToOCRValue = ocrSelected
            let sendFilesToOCR = (ocrSelected === 'Extraer entidades' || ocrSelected === ENV.REACT_APP_OPTIONS_SEND_DOCUMENT_TO_OCR_ALL_DOCUMENTS) ? true : false
            data.append("sendFilesToOCRValue", sendFilesToOCRValue);
            if (sendFilesToOCR) {
                //Add files if preference is send all documents
                if (preferenceSendAllDocsToOcr) {
                    let copyFiles = [...uploadData.uploadedFiles]
                    let docsShowModal = filterFilesPDF(copyFiles)
                    for (let index = 0; index < docsShowModal.length; index++) {
                        const file = docsShowModal[index];
                        const arrayBuffer = await file.file.arrayBuffer();
                        const pdfDoc = await PDFDocument.load(arrayBuffer);
                        const pages = pdfDoc.getPages();
                        file.id = null
                        file.pages = (pages) ? pages.length : 0
                    }
                    let docsCreditsOCR = setCreditsToDocuments(docsShowModal)
                    let docsToOCR = (docsCreditsOCR && docsCreditsOCR.documentsToOCR) ? docsCreditsOCR.documentsToOCR : []
                    docsToOCR.map((doc) => {
                        if (doc.value) {
                            let docSend = {
                                fileId: doc.id,
                                fileName: doc.name,
                                process: doc.process,
                                processId: doc.processId,
                                pages: doc.pages
                            }
                            dataFilesToOCR.push(docSend)
                        }
                        return doc
                    })
                } else {
                    documentsToOCR.map((doc) => {
                        if (doc.value) {
                            let docSend = {
                                fileId: doc.id,
                                fileName: doc.name,
                                process: doc.process,
                                processId: doc.processId,
                                pages: doc.pages
                            }
                            dataFilesToOCR.push(docSend)
                        }
                        return doc
                    })
                }

                data.append("sendFilesToOCR", sendFilesToOCR);
                data.append('dataFilesToOCR', JSON.stringify(dataFilesToOCR))
            }

            const response = await categoryService.saveDocumentDigitalVault(token, data);
            if (response.statusCode == 200) {
                setShowLoadingRequesting(false);
                setShowCompletedRequesting(true);
                setTimeout(() => {
                    setShowCompletedRequesting(false);
                    history.push("/");
                }, 4000);
            } else {
                setShowLoadingRequesting(false);
                toggleErrorRequesting(true, response.message || t("digitalVaultUploadView.errors.general.save"), 4000, false)
            }
        } catch (e) {
            setShowLoadingRequesting(false);
            toggleErrorRequesting(true, e.message, 4000, false)
        }
    }

    useEffect(() => {
        const localStorageService = new LocalStorageService()
        const user = localStorageService.getLocalStorageItem("user")

        loadCompanies();
        getTypeDocuments('Documento');
    }, [])

    useEffect(() => {
        if (!documentData || !documentData.id) return
        let url = (documentData && documentData.files && documentData.files.length > 0 && documentData.files[0].url) ? documentData.files[0].url : ''
        let fileType = (documentData && documentData.files && documentData.files.length > 0 && documentData.files[0].fileType) && documentData.files[0].fileType
        let name = (documentData && documentData.name) ? documentData.name : ''
        let newData = {
            infoType: (documentData.infoType === 'Expediente') ? 2 : 1,
            name: name,
            companyId: null,
            categoryId: null,
            pathBreadcrumb: [],
            typeDocument: null,
            uploadedFiles: documentData.infoType === 'Expediente' ? documentData.files : [],
        }

        //GET document info and pages
        getDocumentPages()
        setFileType(fileType)
        setUrlPdf(url)
        setBlobAWS(url)
        setShowUploadBtn(false)
        setUploadData(newData)
        setShowBtnCancel(true)
    }, documentData)

    useEffect(() => {
        if (!documentData || !documentData.id || !documentData.companyId || !companies || companies.length === 0) return
        let pathBreadcrumb = []
        if (documentData.pathBreadcrumb) {
            let pathBreadcrumbSplit = documentData.pathBreadcrumb.split('/')
            pathBreadcrumbSplit.map(subCatId => pathBreadcrumb.push(Number(subCatId)))
        }

        setUploadData(prev => {
            return {
                ...prev,
                companyId: documentData.companyId,
                categoryId: documentData.categoryParent || null,
                pathBreadcrumb: pathBreadcrumb
            }
        })
    }, [companies, documentData])

    useEffect(() => {
        if (!documentData || !documentData.id || !documentData.typeDocumentId || !typeDocuments || typeDocuments.length === 0) return
        let typeDocument = typeDocuments.find(typeDoc => typeDoc.id === documentData.typeDocumentId)
        setUploadData(prev => {
            return {
                ...prev,
                typeDocument: typeDocument || null
            }
        })
    }, [typeDocuments, documentData])

    const handleUpdateDocument = async (searcPreference, ocrSelected) => {
        if (!validateUpdateData()) {
            toggleErrorRequesting(true, t("digitalVaultUploadView.errors.complete.all.fields"), 3000, false);
            return;
        };
        setShowLoadingRequesting(true)
        let name = uploadData.name
        let alias = documentData.alias
        let description = documentData.description
        let startDate = documentData.startDate
        let validation = documentData.validation
        let amount = documentData.amount
        let confidential = documentData.confidential
        let mandatory = documentData.mandatory
        let penalty = documentData.penaltyFee
        let tags = []
        let variables = []
        let entities = []
        let companyId = uploadData.companyId
        let categoryId = uploadData.pathBreadcrumb[uploadData.pathBreadcrumb.length - 1]
        let pathBreadcrumb = [uploadData.categoryId, ...uploadData.pathBreadcrumb].join('/')
        let workflowEXP = documentData.infoType === 'Expediente' ? true : null
        let typeDocument = {
            typeDocumentId: (uploadData && uploadData.typeDocument.id && uploadData.typeDocument.id > 0) ? uploadData.typeDocument.id : null,
            newTypeDocument: (uploadData && uploadData.typeDocument && uploadData.typeDocument.name && (!uploadData.typeDocument.id || uploadData.typeDocument.id < 0)) ? uploadData.typeDocument : null
        }

        if (searcPreference) {
            let showModalOCR = true
            let userPreferences = await preferenceService.getClientPreferences(token, timezone);
            let sendDocsToOcrPreference = userPreferences.data.find(preference => preference.preferenceName === process.env.REACT_APP_PREFERENCE_DOCUMENT_TO_OCR)
            if (sendDocsToOcrPreference) {
                let preferenceOCR = (!sendDocsToOcrPreference.stringValue || (sendDocsToOcrPreference.stringValue && sendDocsToOcrPreference.stringValue === ENV.REACT_APP_OPTIONS_SEND_DOCUMENT_TO_OCR_USER_SELECT)) ? true : false
                if (!preferenceOCR) showModalOCR = false
            }

            //Verify preference if is active show modal to select if send document to OCR or not
            if (showModalOCR) {
                setShowLoadingRequesting(false)
                setShowDialogSendDocToOcr(true)
                return
            }
        }

        let dataFilesToOCR = []
        let sendFilesToOCRValue = ocrSelected
        let sendFilesToOCR = (ocrSelected === 'Extraer entidades' || ocrSelected === ENV.REACT_APP_OPTIONS_SEND_DOCUMENT_TO_OCR_ALL_DOCUMENTS) ? true : false
        if (sendFilesToOCR) {
            documentsToOCR.map((doc) => {
                if (doc.value) {
                    let docSend = {
                        fileId: doc.id,
                        fileName: doc.name,
                        process: doc.process,
                        processId: doc.processId,
                        pages: doc.pages
                    }
                    dataFilesToOCR.push(docSend)
                }
                return doc
            })
        }
        setShowLoadingRequesting(false)
        handleSaveData(alias, description, startDate, validation, amount, confidential, mandatory, penalty, tags, entities, variables, name, categoryId, companyId, pathBreadcrumb, workflowEXP, null, typeDocument, sendFilesToOCR, dataFilesToOCR, sendFilesToOCRValue)
    }

    const handleWathchExp = (doc) => {
        switch (doc.fileType) {
            case null:
                setFileType("pdf")
                break
            default:
                setFileType(doc.fileType)
                setUrlPdf(doc.url)
                return
        }
        /** @type {string} */
        let url = (doc.url) ? doc.url : ''
        setUrlPdf(url)
    }

    const rejectUploadDocument = async () => {
        setShowLoadingRequesting(true);
        let errorMessage = t("digitalVaultUploadView.errors.general.reject")
        try {
            let documentRejected = await digitalVaultDocumentService.rejectDocument(documentId, token)
            if (documentRejected && documentRejected.data && Number(documentRejected.statusCode) === 200) {
                setShowLoadingRequesting(false);
                setShowCompletedRequesting(true);
                setTimeout(() => {
                    setShowCompletedRequesting(false);
                    history.push("/");
                }, 4000);
            } else {
                setShowLoadingRequesting(false);
                toggleErrorRequesting(true, errorMessage, 4000, false)
            }
        } catch (error) {
            setShowLoadingRequesting(false);
            toggleErrorRequesting(true, errorMessage, 4000, false)
        }
    }

    const getDocumentPages = async () => {
        let errorMessage = t("digitalVaultUploadView.errors.general.document")

        try {
            let document = await digitalVaultDocumentService.getDocumentPages(documentId, token)
            if (document && document.data && Number(document.statusCode) === 200) {
                let docsCreditsOCR = setCreditsToDocuments(document.data.files)
                let docsToOCR = (docsCreditsOCR && docsCreditsOCR.documentsToOCR) ? docsCreditsOCR.documentsToOCR : []
                let totalCredits = (docsCreditsOCR && docsCreditsOCR.totalCredits) ? docsCreditsOCR.totalCredits : 0

                setTotalCredits(totalCredits)
                setDocumentsToOCR(docsToOCR)
            } else {
                toggleErrorRequesting(true, errorMessage, 4000, false)
            }
        } catch (error) {
            toggleErrorRequesting(true, errorMessage, 4000, false)

        }
    }

    const closeModalSendToOcr = () => {
        setShowDialogSendDocToOcr(false)
    }

    const handleCheckBoxDoc = (e, dataItem) => {
        let copyDocs = [...documentsToOCR]
        let valueCheck = e.target.checked
        let totalCredits = 0
        copyDocs = copyDocs.map((doc) => {
            if (doc.id === dataItem.id) {
                doc.value = valueCheck
            }

            if (doc.value) {
                totalCredits = totalCredits + doc.credits
            }
            return doc
        })

        setDocumentsToOCR(copyDocs)
        setTotalCredits(totalCredits)
    }

    const setCreditsToDocuments = (documents) => {
        let docsToOCR = []
        let totalCredits = 0
        documents.map((doc) => {
            let pages = doc.pages
            let credits = Number(ENV.REACT_APP_OCR_ENTITIES_CREDITS)
            let addPagesOCR = Number(ENV.REACT_APP_OCR_PAGES)
            let addPagesEntities = Number(ENV.REACT_APP_ENTITIES_PAGES)
            let totalCredtisOCR = countCreditsByPages(pages, credits, addPagesOCR)
            let totalCredtisEntities = countCreditsByPages(pages, credits, addPagesEntities)

            let ocrDoc = {
                id: doc.id,
                name: doc.name,
                pages: doc.pages,
                process: t("digitalVaultUploadView.process.ocr"),
                unitary: `${process.env.REACT_APP_CREDITS_PROCESS_OCR} ${t("digitalVaultUploadView.credits.by")} ${process.env.REACT_APP_NUMBER_PAGES_CREDITS_OCR} ${t("digitalVaultUploadView.pages")}`,
                credits: totalCredtisOCR,
                value: true,
                processId: 1
            }

            let entitiesDoc = {
                id: doc.id,
                name: doc.name,
                pages: doc.pages,
                process: t("digitalVaultUploadView.process.entity.extraction"),
                unitary: `${process.env.REACT_APP_CREDITS_PROCESS_ENTITY_EXTRACTION} ${t("digitalVaultUploadView.credits.by")} ${process.env.REACT_APP_NUMBER_PAGES_CREDITS_ENTITY_EXTRACTION} ${t("digitalVaultUploadView.pages")}`,
                credits: totalCredtisEntities,
                value: true,
                processId: 2
            }

            docsToOCR.push(ocrDoc)
            docsToOCR.push(entitiesDoc)

            totalCredits = totalCredits + totalCredtisOCR + totalCredtisEntities
        })

        let data = {
            documentsToOCR: docsToOCR,
            totalCredits
        }
        return data
    }

    const getTypeDocuments = async (typeDocumentParam) => {
        const responseDocType = await categoryService.getTypeDocuments(token, typeDocumentParam);
        if (responseDocType.statusCode == 200 && responseDocType.data) {
            let typeDocumentOptions = responseDocType.data;
            typeDocumentOptions.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
            setTypeDocuments(typeDocumentOptions);
        } else {
            throw new Error(responseDocType.message || t("digitalVaultUploadView.errors.general.type.file"))
        }
    }

    return (
        <DigitalVaultUploadView
            {...props}
            setFileType={setFileType}
            fileType={fileType}
            infoTypes={infoTypes}
            companies={companies}
            categories={categories}
            subcategoryTree={subcategoryTree}
            typeDocuments={typeDocuments}

            handleFile={handleFiles}
            deleteFile={deleteFile}
            uploadData={uploadData}
            handleUploadDataChange={handleUploadDataChange}

            onCancel={onCancel}
            onSave={onSave}
            invalidFields={invalidFields}
            setInvalidFields={setInvalidFields}

            isLoading={isLoading}
            toggleLoadingScreen={setIsLoading}
            showLoadingRequesting={showLoadingRequesting}
            toggleLoadingRequesting={setShowLoadingRequesting}
            showErrorRequesting={showErrorRequesting}
            toggleErrorRequesting={toggleErrorRequesting}
            messageError={messageError}
            showCompletedRequesting={showCompletedRequesting}
            toggleCompletedRequesting={setShowCompletedRequesting}

            documentId={documentId}
            handleUpdateDocument={(noWorkflow) ? handleSubmitNoWorkflow : handleUpdateDocument}
            handleWathchExp={handleWathchExp}
            documentData={documentData}
            urlPdf={urlPdf}
            blobAWS={blobAWS}

            showUploadBtn={showUploadBtn}

            showBtnCancel={showBtnCancel}
            rejectUploadDocument={rejectUploadDocument}

            showDialogSendDocToOcr={showDialogSendDocToOcr}
            closeModalSendToOcr={closeModalSendToOcr}

            documentsToOCR={documentsToOCR}
            handleCheckBoxDoc={handleCheckBoxDoc}
            totalCredits={totalCredits}
        />
    )
}

export default withRouter(withTranslation()(DigitalVaultUploadAction));